import { render } from "./EditAvatar.vue?vue&type=template&id=226da5d9&scoped=true&ts=true"
import script from "./EditAvatar.vue?vue&type=script&lang=ts"
export * from "./EditAvatar.vue?vue&type=script&lang=ts"

import "./EditAvatar.vue?vue&type=style&index=0&id=226da5d9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-226da5d9"],['__file',"src/components/profile/EditAvatar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "226da5d9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('226da5d9', __exports__)) {
    api.reload('226da5d9', __exports__)
  }
  
  module.hot.accept("./EditAvatar.vue?vue&type=template&id=226da5d9&scoped=true&ts=true", () => {
    api.rerender('226da5d9', render)
  })

}


export default __exports__